import { Component } from '@angular/core'
import { OccConfig } from '@spartacus/core'
import { DefaultRowComponent } from '../default-row/default-row.component'

@Component({
  selector: 'app-product-updates-row',
  templateUrl: './product-updates-row.component.html',
  styleUrl: './product-updates-row.component.scss',
  standalone: false
})
export class ProductUpdatesRowComponent extends DefaultRowComponent {
  constructor(public occConfig: OccConfig) {
    super()
  }
}
